require('./filterController');

angular.module('app.shared.clipSearch.filterDirective', [
  'app.shared.clipSearch.filterDirective.filterController'
])
  .directive('clipSearchFilter', [
    function () {
      "use strict";
      return {
        templateUrl: 'components/shared/clipSearch/filterDirective/filterDirectiveView.html',
        controller: 'app.shared.clipSearch.filterDirective.filterController',
        scope: {
          filterData: '=',
          cachedFilterData: '=?',
          button: '<?',
          filterTemplate: '<?',
          emptyFilterTemplate: '<?',
          hideFilterActions:'=?',
          canUpdatePresets: '=?',
          hideClipCount: '=?',
          defaultValue: '=?'
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/clipSearch/filterDirective/filterDirective.js